/**
 * The admin route table (`CR-006`, `ARCH-001 §4`).
 *
 * Same rule as the user app's: **this is the only file in the console that contains a path string.** It is
 * deliberately a second table rather than a shared one — `ARCH-001 §4` is explicit that no admin route ever
 * ships in the user app, and a shared table would put every admin path into the user bundle to be read by
 * anyone who opened dev tools.
 */

/** Every route the console has, by name. */
export type RouteName = 'dashboard' | 'notFound';

/** Name to path. Frozen, so nothing can rewrite a route at runtime. */
export const routePaths = Object.freeze({
  dashboard: '/',
  notFound: '*',
} as const satisfies Record<RouteName, string>);

/** The path for a route. Everything that navigates goes through this rather than typing a literal. */
export function pathTo(route: RouteName): string {
  return routePaths[route];
}
